// extracted by mini-css-extract-plugin
export var container = "spaceflight-section-module--container--M73VT";
export var inner = "spaceflight-section-module--inner--EbL2N";
export var contentParagraph = "spaceflight-section-module--content-paragraph--nipYf";
export var flightpathWrapper = "spaceflight-section-module--flightpath-wrapper--qx5Lz";
export var imageWrapper = "spaceflight-section-module--image-wrapper--q1hbm";
export var image = "spaceflight-section-module--image---mn17";
export var flightpathActions = "spaceflight-section-module--flightpath-actions--00FxG";
export var flightpathTitle = "spaceflight-section-module--flightpath-title--zL-Ig";
export var content = "spaceflight-section-module--content--RNFx+";